import { render, staticRenderFns } from "./PagamentoTerminal.vue?vue&type=template&id=ad908bf8&scoped=true"
import script from "./PagamentoTerminal.vue?vue&type=script&lang=js"
export * from "./PagamentoTerminal.vue?vue&type=script&lang=js"
import style0 from "./PagamentoTerminal.vue?vue&type=style&index=0&id=ad908bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad908bf8",
  null
  
)

export default component.exports